import React from "react";
import { useViewState } from "./hooks/useState";

const Header = () => {
  const { translations } = useViewState();

  return React.useMemo(
    () => (
      <div className="m-pageHeader -withIcon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="55"
          height="55"
          viewBox="0 0 55 55"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#66182a"
            transform="translate(1 1)"
          >
            <circle cx="26.5" cy="26.5" r="26.5" strokeWidth="2" />
            <circle cx="28.25" cy="24.75" r="8.75" strokeWidth="3" />
            <path
              strokeLinecap="round"
              strokeWidth="3"
              d="M21.95 31.05l-5.6 5.6"
            />
          </g>
        </svg>
        {translations.findPrevia && (
          <h1 className="m-pageHeader__heading">{translations.findPrevia}</h1>
        )}
      </div>
    ),
    [translations]
  );
};

export default Header;
